// 我们组装模块并导出 store 的地方
import Vue from 'vue'
import Vuex from 'vuex'
import mystate from "./modules/mystate";
import float from "./modules/float";

// 注册Vuex
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    mystate,
    float
  },
})



// WEBPACK FOOTER //
// ./src/store/index.js